import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Pages
import CheckEmailMessagePage from "pages/LoginOrRegisterPages/CheckEmailMessagePage/CheckEmailMessagePage";
import ConfirmCONPage from "pages/LoginOrRegisterPages/ConfirmCONPage/ConfirmCONPage";
import ContinueToAccountOrLogoutPage from "pages/ContinueToAccountOrLogoutPage/ContinueToAccountOrLogoutPage";
import LoadingPage from "pages/LoadingPage/LoadingPage";
import LoginOrRegisterPage from "pages/LoginOrRegisterPages/LoginOrRegisterPage/LoginOrRegisterPage";
import LoginPage from "pages/LoginOrRegisterPages/LoginPage/LoginPage";
import TwoFactorLoginPage from "pages/LoginOrRegisterPages/LoginPage/TwoFactorLoginPage";
import TokenExpiredPage from "pages/RegistrationPages/TokenExpiredPage/TokenExpiredPage";

// Actions
import { isSignedIn } from "store/slices/accountSlice";
import { setContent } from "store/slices/applicationSlice";
import { setLoader } from "store/slices/loadersSlice";

export default function LoginOrRegisterPages() {
  const { content } = useSelector(({ application }) => application);
  const { isLoader } = useSelector(({ loaders }) => loaders);

  // Redux
  const reduxDispatch = useDispatch();

  // Constants
  const PAGES = Object.freeze({
    checkMail: <CheckEmailMessagePage />,
    continueToAccountOrLogoutPage: <ContinueToAccountOrLogoutPage />,
    confirmAccount: <ConfirmCONPage />,
    login: <LoginPage />,
    twoFactorLogin: <TwoFactorLoginPage />,
    loginOrRegister: <LoginOrRegisterPage />,
    tokenExpired: <TokenExpiredPage />,
  });

  useEffect(() => {
    reduxDispatch(isSignedIn()).then(result => {
      const { signedIn } = result.payload;
      const redirectToPage = signedIn ? "continueToAccountOrLogoutPage" : "loginOrRegister";

      reduxDispatch(setContent(redirectToPage));
      reduxDispatch(setLoader(false));
    });
  }, []);

  return isLoader ? (
    <LoadingPage title="Welcome" content="Checking your details" />
  ) : (
    PAGES[content]
  );
}
